import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { registerLocaleData } from "@angular/common";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import localeSl from "@angular/common/locales/sl";
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatBottomSheet, MatDialog } from "@angular/material";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../environments/environment";
import { BottomSheetItemDescriptionComponent } from "../_components/bottom-sheet-item-description/bottom-sheet-item-description.component";
import { LanguageService } from "../_services/language.service";
import { PriceWeightService } from "../_services/price-weight.service";
import { CustomStepperComponent } from "../custom-stepper/custom-stepper.component";
import { MyModalComponent } from "../modals/my-modal/my-modal.component";

registerLocaleData(localeSl, "sl");

export interface Dealer {
  value: string;
  viewValue: string;
}

@Component({
  selector: "app-configurator",
  templateUrl: "./configurator.component.html",
  styleUrls: ["./configurator.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger("slideIntroPanel", [
      state(
        "leave",
        style({
          flex: "0",
          width: 0,
        })
      ),
      state(
        "enter",
        style({
          flex: "1 1 50%",
        })
      ),
      transition("* => leave", animate("300ms cubic-bezier(0.35, 0, 0.25, 1)")),
      transition("* => enter", animate("400ms cubic-bezier(0.35, 0, 0.25, 1)")),
    ]),
    trigger("slideIntroContent", [
      state(
        "leave",
        style({
          flex: "1 1 100%",
        })
      ),
      state(
        "enter",
        style({
          flex: "1 1 50%",
        })
      ),
      transition("* => leave", animate("300ms cubic-bezier(0.35, 0, 0.25, 1)")),
      transition("* => enter", animate("400ms cubic-bezier(0.35, 0, 0.25, 1)")),
    ]),
  ],
})
export class ConfiguratorComponent implements OnInit {
  placeOrderForm = new FormGroup({
    customerName: new FormControl(null, { validators: [Validators.required] }),
    customerLastName: new FormControl(null, {
      validators: [Validators.required],
    }),
    customerAddress: new FormControl(null, {
      validators: [Validators.required],
    }),
    customerCity: new FormControl(null, { validators: [Validators.required] }),
    customerZIP: new FormControl(null, { validators: [Validators.required] }),
    customerCountry: new FormControl(null, {
      validators: [Validators.required],
    }),
    customerEmail: new FormControl(null, {
      validators: [Validators.required, Validators.email],
    }),
    customerPhone: new FormControl(null, { validators: [Validators.required] }),
    selectedDealer: new FormControl(null),
    GDPRconsent: new FormControl(null, { validators: [Validators.required] }),
    Newsletter: new FormControl(false),
  });

  @ViewChild("scroll") _scroll: ElementRef;

  public lastScrolledHeight = 0;
  public showAddButton = true;
  public edited = false;
  public href = "";

  agree_text: any = "";
  newsletter_text: any = "";
  settings_text: any = "";
  offer_text: any = "";
  tax: any = 0;
  currency = "";
  dealers: any = [];

  data: any = [];
  ident: any = [];
  description: any = [];
  image: any = [];
  weight: number;
  options: any = {
    ident: "",
    optionN: "",
    optionIdent: "",
    name: "",
    description: "",
    image: "",
    weight: "",
    price: "",
  };
  selected: any = [];
  prices: any = {
    skupaj: "",
  };

  formSubmited: any = false;
  @ViewChild("stepper") stepper: CustomStepperComponent;
  private activatedRoute: any;

  constructor(
    private priceWeight: PriceWeightService,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    private _snackBar: MatSnackBar,
    private languageService: LanguageService,
    private router: Router,
    private route: ActivatedRoute,
    private bottomSheet: MatBottomSheet
  ) {}

  public introPanelShown = "leave";
  public animatedDiv = true;
  public isDisplayed = true;
  private animacija: ElementRef;

  public toggleIntro(): void {
    this.introPanelShown = this.introPanelShown === "enter" ? "leave" : "enter";
  }

  ngOnInit() {
    this.initializeLocale();
  }

  private initializeLocale(): void {
    const queryCountry = this.route.snapshot.queryParams['country'];
    const queryLocale = this.route.snapshot.queryParams['locale'];

    if (queryCountry && queryLocale) {
      this.validateAndSetLocale(queryCountry, queryLocale);
    } else if (this.languageService.hasValidSelection()) {
      this.validateAndSetLocale(
        this.languageService.selectedCountry,
        this.languageService.selectedLocale
      );
    } else {
      this.openDialog();
    }
  }

  private validateAndSetLocale(country: string, locale: string): void {
    this.languageService.getLocales().subscribe(
      () => {
        const isValid = this.languageService.validateCountryLocaleSync(country, locale);
        if (isValid) {
          this.languageService.setLocaleAndCountry(locale, country);
          this.loadConfigurationData();
        } else {
          this.languageService.clearStorage();
          this.openDialog();
        }
      },
      error => {
        console.error('Error validating locale:', error);
        this.openDialog();
      }
    );
  }

  private loadConfigurationData(): void {
    this.getConfigurationData();
    this.getDealers();
  }

  getDealers() {
    if (this.router.url.includes("dealer")) {
      const selectedDealer = this.route.snapshot.queryParams["dealer"];
      console.log(selectedDealer);
      this.placeOrderForm.controls["selectedDealer"].setValue(selectedDealer);
      this.placeOrderForm.controls["selectedDealer"].clearValidators();
      this.edited = true;
    } else {
      const headers = new HttpHeaders().set(
        "Auth-token",
        "hsd76bk0c6D6ac73s7D7fE4hF3b3a13cDf53Shbs1"
      );
      const params = new HttpParams().set(
        "country",
        this.languageService.selectedCountry
      );

      this.httpClient
        .get(`${environment.apiUrl}configuration/dealers`, {
          headers: headers,
          params: params,
        })
        .subscribe(
          (data) => {
            this.dealers = data;
            console.log(this.dealers);
            /*this.parseData(data);
                    console.log('Izbrana konfig.:', this.selected);
                    this.priceWeight.weight = this.getTotalWeight();
                    this.priceWeight.price = this.getTotalPrice();
                    this.stepper.next();
                    */
          },
          (error) => {
            console.log("Error", error);
          }
        );
      this.placeOrderForm.controls["selectedDealer"].setValidators(
        Validators.required
      );
      this.edited = false;
    }
  }

  getConfigurationData() {
    /*const httpOptions = {

        };*/
    /*
        const headers: new HttpHeaders().set{
            'Auth-token': 'hsd76bk0c6D6ac73s7D7fE4hF3b3a13cDf53Shbs1',
        );
        */

    const headers = new HttpHeaders().set(
      "Auth-token",
      "hsd76bk0c6D6ac73s7D7fE4hF3b3a13cDf53Shbs1"
    );

    const params = new HttpParams()
      .set("locale", this.languageService.selectedLocale)
      .set("country", this.languageService.selectedCountry);
    // const opts = { params: new HttpParams({fromString: "_page=1&_limit=10"}) };

    this.httpClient
      .get(`${environment.apiUrl}configuration`, {
        headers: headers,
        params: params,
      })
      .subscribe(
        (data) => {
          this.parseData(data);
          console.log("Izbrana konfig.:", this.selected);
          this.priceWeight.weight = this.getTotalWeight();
          this.priceWeight.price = this.getTotalPrice();
          this.stepper.next();
        },
        (error) => {
          console.log("Error", error);
        }
      );
  }

  showBottomSheet(item: any): void {
    this.bottomSheet.open(BottomSheetItemDescriptionComponent, {
      data: item,
    });
  }

  parseData(data: any) {
    console.log(data);
    this.data = data;

    let i = 0;

    this.currency = data.currency;
    this.tax = data.tax;
    this.settings_text = data.settings_text;
    this.offer_text = data.offer_text;
    this.agree_text = data.agree_text;
    this.newsletter_text = data.newsletter_text;

    for (const step of data.steps) {
      if (step.subcategory.length === 0) {
        /*
                this.selected[i] = {
                    n: step.n,
                    ident: step.ident,
                    name: step.name,
                    isDefault: step.options[0].is_default,
                    optionN: step.options[0].n,
                    optionIdent: step.options[0].ident,
                    optionName: step.options[0].name,
                    optionImage: step.options[0].image,
                    optionPrice: step.options[0].price,
                    optionWeight: step.options[0].weight,
                    categoryType: step.category_type,
                };
                */

        for (const option of step.options) {
          if (option.is_default === 1) {
            this.selected[i] = {
              n: step.n,
              ident: step.ident,
              name: step.name,
              isDefault: option.is_default,
              optionN: option.n,
              optionIdent: option.ident,
              optionName: option.name,
              optionImage: option.image,
              optionPrice: option.price,
              optionWeight: option.weight,
              categoryType: step.category_type,
            };

            i++;
          }
        }
      } else {
        for (const subcategory of step.subcategory) {
          if (subcategory.options.length > 0) {
            for (const subOption of subcategory.options) {
              if (subOption.is_default === 1) {
                this.selected[i] = {
                  n: step.n,
                  ident: subcategory.ident,
                  name: subcategory.name,
                  isDefault: subOption.is_default,
                  optionN: subOption.n,
                  optionIdent: subOption.ident,
                  optionName: subOption.name,
                  optionImage: subOption.image,
                  optionPrice: subOption.price,
                  optionWeight: subOption.weight,
                  categoryType: subcategory.category_type,
                };

                i++;
              }
            }
          }
        }
      }
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(MyModalComponent, {
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getConfigurationData();
      this.getDealers();
    });
  }

  findElement(item) {
    return (
      Object.values(this.selected).filter(
        (e: any) => e.optionIdent === item.ident
      ).length > 0
    );
  }

  checkDisplayElement(categoryType, exclude) {
    if (categoryType === 2) {
      return "block";
    } else {
      // console.log(this.getSelectedModelId());

      if (
        exclude.split(",").indexOf("" + this.getSelectedModelId() + "") !== -1
      ) {
        return "block";
      } else {
        return "none";
      }
    }
  }

  setOptionSelected(item, step) {
    if (
      Object.values(this.selected).filter((e: any) => e.ident === step.ident)
        .length > 0
    ) {
      // var selectedKey = Object.keys(this.selected).find(e => e.ident === step.ident);

      const selectedKey = Object.values(this.selected).findIndex(
        (x: any) => x.ident === step.ident
      );
      this.selected[selectedKey] = {
        ident: step.ident,
        name: step.name,
        optionN: item.n,
        optionIdent: item.ident,
        optionName: item.name,
        optionPrice: item.price,
        optionImage: item.image,
        optionWeight: item.weight,
        categoryType: step.category_type,
      };
    } else {
      const totalLength = Object.keys(this.selected).length;
      this.selected[totalLength] = {
        ident: step.ident,
        name: step.name,
        optionN: item.n,
        optionIdent: item.ident,
        optionName: item.name,
        optionPrice: item.price,
        optionImage: item.image,
        optionWeight: item.weight,
        categoryType: step.category_type,
      };
    }
    this.priceWeight.weight = this.getTotalWeight();
    this.priceWeight.price = this.getTotalPrice();

    // console.log(this.getSelectedModelId());
  }

  setOptionSubCatSelected(item, step, subcategory) {
    //console.log("dela");

    if (
      step.category_type === 1 &&
      Object.values(this.selected).filter(
        (e: any) =>
          e.ident === subcategory.ident && e.optionIdent === item.ident
      ).length > 0
    ) {
      // extras
      // var selectedKey = Object.values(this.selected).findIndex(x => x.ident === subcategory.ident && x.optionIdent === item.ident);
      // delete this.selected[selectedKey];

      //prvo dobimo step kategorije
      const stepIndex: number = Object.values(this.data.steps).findIndex(
        (x: any) => x.ident === step.ident
      );
      //console.log(stepIndex);

      //iz step kategorije najdemo index da lahko uporabimo options seznam
      const subCategoryIndex: number = Object.values(
        this.data.steps[stepIndex].subcategory
      ).findIndex((x: any) => x.ident === subcategory.ident);
      //console.log(subCategoryIndex);

      //če ima opcija znotraj podkategorijo opcijo z 0 ne pustimo brisanja
      if (
        step.category_type === 1 &&
        Object.values(
          this.data.steps[stepIndex].subcategory[subCategoryIndex].options
        ).filter((e: any) => e.price === 0).length > 0
      ) {
        //console.log('obstaja options');
      } else {
        //če ne se odstrani
        const index: number = Object.values(this.selected).findIndex(
          (x: any) =>
            x.ident === subcategory.ident && x.optionIdent === item.ident
        );
        if (index !== -1) {
          this.selected.splice(index, 1);
        }
      }
    } else {
      if (
        Object.values(this.selected).filter(
          (e: any) => e.ident === subcategory.ident
        ).length > 0
      ) {
        const selectedKey = Object.values(this.selected).findIndex(
          (x: any) => x.ident === subcategory.ident
        );
        this.selected[selectedKey] = {
          ident: subcategory.ident,
          name: subcategory.name,
          optionN: item.n,
          optionIdent: item.ident,
          optionName: item.name,
          optionImage: item.image,
          optionPrice: item.price,
          optionWeight: item.weight,
          categoryType: subcategory.category_type,
        };
      } else {
        const totalLength = Object.values(this.selected).length;
        this.selected[totalLength] = {
          ident: subcategory.ident,
          name: subcategory.name,
          optionN: item.n,
          optionIdent: item.ident,
          optionName: item.name,
          optionImage: item.image,
          optionPrice: item.price,
          optionWeight: item.weight,
          categoryType: subcategory.category_type,
        };
      }
    }

    this.priceWeight.weight = this.getTotalWeight();
    this.priceWeight.price = this.getTotalPrice();

    // console.log(this.getSelectedModelId());
  }

  setCheckSelected(item, step, subcategory) {
    if (
      step.category_type === 1 &&
      Object.values(this.selected).filter(
        (e: any) =>
          e.ident === subcategory.ident && e.optionIdent === item.ident
      ).length > 0
    ) {
      const index: number = Object.values(this.selected).findIndex(
        (x: any) =>
          x.ident === subcategory.ident && x.optionIdent === item.ident
      );
      if (index !== -1) {
        this.selected.splice(index, 1);
      }
    } else {
      const totalLength = Object.keys(this.selected).length;
      this.selected[totalLength] = {
        ident: subcategory.ident,
        name: subcategory.name,
        optionN: item.n,
        optionIdent: item.ident,
        optionName: item.name,
        optionImage: item.image,
        optionPrice: item.price,
        optionWeight: item.weight,
        categoryType: subcategory.category_type,
      };
    }
    this.priceWeight.weight = this.getTotalWeight();
    this.priceWeight.price = this.getTotalPrice();
  }

  getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
  }

  getSelectedModelId() {
    const filter_array = Object.values(this.selected).filter(
      (x: any) => x.categoryType === 2
    );
    // const result = filter_array[Object.keys(filter_array)[0]];
    // console.log('filter arry:', result);
    // console.log('filter arry:', filter_array);
    // if (result) {
    //     return result;
    // } else {
    //     return '';
    // }
    // return result.optionName;
    return filter_array[0]["optionN"];
  }

  getSelectedModel() {
    // const result = filter_array[Object.keys(filter_array)[0]];
    // console.log('filter arry:', result);
    // console.log('filter arry:', filter_array);
    // if (result) {
    //     return result;
    // } else {
    //     return '';
    // }
    // return result.optionName;
    return Object.values(this.selected).filter(
      (x: any) => x.categoryType === 2
    );
  }

  getConfigurationSelected() {
    return Object.values(this.selected).filter(
      (x: any) => x.categoryType === 0
    );
  }

  getExtrasSelected() {
    return Object.values(this.selected).filter(
      (x: any) => x.categoryType === 1
    );
  }

  getTotalPrice() {
    let totalPrice = 0;
    // console.log('Price start:', totalPrice);
    for (const item of this.selected) {
      if (item.optionPrice) {
        totalPrice += Number(item.optionPrice);
        // console.log('Price now:', totalPrice);
      }
    }
    // console.log('Total price:', totalPrice);
    return totalPrice;
  }

  getTotalWeight() {
    let totalWeight = 0;
    // console.log('Weight start:', totalWeight);
    for (const item of this.selected) {
      if (item.optionWeight) {
        totalWeight += Number(item.optionWeight);
        // console.log('Weight now:', totalWeight);
      }
    }
    // console.log('Total weight:', totalWeight);
    return totalWeight;
  }

  onSubmit() {
    console.log(this.selected);
    this.formSubmited = true;

    const headers = new HttpHeaders().set(
      "Auth-token",
      "hsd76bk0c6D6ac73s7D7fE4hF3b3a13cDf53Shbs1"
    );
    const params = new HttpParams()
      .set("form", this.placeOrderForm.value)
      .set("selected", this.selected)
      .set("locale", this.languageService.selectedLocale)
      .set("country", this.languageService.selectedCountry);

    this.httpClient
      .post(
        `https://b2b.podlunsek.com/api/inquiry`,
        {
          locale: this.languageService.selectedLocale,
          country: this.languageService.selectedCountry,
          form: this.placeOrderForm.value,
          selected: this.selected,
          // doplacila: this.doplacila,
        },
        { headers: headers }
      )
      .subscribe(
        (data) => {
          this._snackBar.open("Uspešno shranjeno!");
          this.formSubmited = false;

          // this.stepper.selectedIndex = 0;
          // this.toggleIntro();
          // this.router.navigate(['https://config.podlunsek.com/thank-you.html']);
          window.location.href = "https://config.podlunsek.com/thank-you.html";
        },
        (error) => {
          this.formSubmited = false;
        }
      );
  }

  public onStepChange(event: any): void {
    if (event.selectedIndex === 0) {
      this.toggleIntro();
      this.openDialog();
    }
  }

  @ViewChildren("nekaj") set content(content: ElementRef) {
    this.animacija = content;
    this.isDisplayed = true;
    /*if (this.animacija) {
            this.hideAnimatedDiv();
        }*/
  }

  setDisplayOff() {
    this.isDisplayed = false;
  }

  hideAnimatedDiv() {
    setTimeout(() => {
      console.log("skriiiij");
      this.isDisplayed = false;
    }, 3000);
  }

  /*ALEN_DRUŽE_KODA za get data iz API-ja*/
  // getData() {
  //     const httpOptions = {
  //         headers: new HttpHeaders({
  //             'Auth-token': 'hsd76bk0c6D6ac73s7D7fE4hF3b3a13cDf53Shbs1',
  //         })
  //     };
  //
  //     // let params = new HttpParams().set('language', 'sl');
  //
  //     this.httpClient.get(`${environment.apiUrl}`, httpOptions).subscribe(
  //         data => {
  //             console.log(data);
  //             this.data = data;
  //
  //             // this.selected.modelOption = this.data.steps[0].options[0];
  //
  //             let i = 0;
  //
  //             for (const step of data.steps) {
  //                 if (step.subcategory.length === 0) {
  //                     this.selected[i] = {
  //                         'ident': step.ident,
  //                         'name': step.name,
  //                         'optionIdent': step.options[0].ident,
  //                         'optionName' : step.options[0].name,
  //                         'optionPrice' : step.options[0].price,
  //                         'optionWeight' : step.options[0].weight,
  //                         'categoryType' : step.category_type
  //                     };
  //                 }
  //                 i++;
  //             }
  //             console.log('Izbrana konfig.:', this.selected);
  //             this.getTotalWeight();
  //         },
  //         error => {
  //             console.log('Error', error);
  //         }
  //     );
  // }
}
